<template>
  <div class="stats-cards">
    <filters @offersFiltersChanged="filtersChanged"></filters>

    <div v-show="isFullPage">
      <div class="card">
        <div class="card-header">
          <h4 class="section-title card-title">{{ $t("Statistic.sections.general.title") }}</h4>
        </div>

        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-md-4 col-sm-12 statistic-number">
              <div class="text-center m-t-10">
                <div class="number-highlight">{{ totalOffersPublished }}</div>
                <div class="text text-content">{{ $t("Statistic.general.number_part.text") }}</div>
              </div>
            </div>

            <div class="col-md-8 col-sm-12">
              <div class="stats-chart completion-of-requests teamsquare-highcharts-color">
                <highcharts :options="completionOfRequests"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h4 class="section-title card-title">{{ $t("Statistic.sections.time_response.title") }}</h4>
        </div>

        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-md-4 col-sm-12 statistic-number">
              <div class="text-center">
                <div class="text text-content">{{ $t("Statistic.sections.time_response.content") }}</div>
                <div class="number-highlight">{{ minTimeFoundCandidate }}</div>
              </div>
            </div>

            <div class="col-md-8 col-sm-12">
              <div class="stats-chart teamsquare-highcharts-color">
                <highcharts :options="responseByTimeStats"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h4 class="section-title card-title">{{ $t("Statistic.sections.distribution_of_requests.title") }}</h4>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-xl-6" v-if="isChart">
              <div class="stats-chart teamsquare-highcharts-color">
                <highcharts :options="offersByServicesStats"></highcharts>
              </div>
              <BtnShowMoreLess
                v-if="enableToggleButton('services')"
                @change_toggle_services="changeToggle"
                :type_of_chart="'services'">
              </BtnShowMoreLess>
            </div>

            <div class="col-xl-6" v-else>
              <div class="stats-chart teamsquare-highcharts-color">
                <highcharts :options="offersByEntitiesStats"></highcharts>
              </div>
              <BtnShowMoreLess
                v-if="enableToggleButton('entities')"
                @change_toggle_services="changeToggle"
                :type_of_chart="'entities'">
              </BtnShowMoreLess>
            </div>

            <div class="col-xl-6">
              <div class="stats-chart teamsquare-highcharts-color">
                <highcharts :options="offersByOccupationsStats"></highcharts>
              </div>
              <BtnShowMoreLess
                v-if="enableToggleButton('occupations')"
                @change_toggle_occupations="changeToggle"
                :type_of_chart="'occupations'">
              </BtnShowMoreLess>
            </div>
          </div>

          <div class="row">
            <div class="col align-self-center" v-if="isChartHub">
                <div class="stats-chart teamsquare-highcharts-color">
                  <highcharts :options="offersByHubsStats"></highcharts>
                </div>
                <BtnShowMoreLess
                  v-if="enableToggleButton('hubs')"
                  @change_toggle_hubs="changeToggle"
                  :type_of_chart="'hubs'">
                </BtnShowMoreLess>
              </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h4 class="section-title card-title">{{ $t("Statistic.sections.replacements.title") }}</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="stats-chart teamsquare-highcharts-color">
                <highcharts :options="reasonsReplacementStats"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="card">
        <div class="card-header">
          <h4 class="section-title card-title">{{ $t("Statistic.sections.top_candidate.title") }}</h4>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="stats-chart teamsquare-highcharts-color">
                <highcharts :options="topCandidateStats"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Filters from "./Filters";
  import BtnShowMoreLess from "./shared/BtnShowMoreLess";
  import { mapActions } from 'vuex'

  export default {
    name: 'Stats',
    components: { Filters, BtnShowMoreLess },
    computed: {
      ...mapGetters({
        completionOfRequests: 'stats/completionOfRequests',
        offersByServicesStats: 'stats/offersByServicesStats',
        offersByEntitiesStats: 'stats/offersByEntitiesStats',
        offersByOccupationsStats: 'stats/offersByOccupationsStats',
        offersByHubsStats: 'stats/offersByHubsStats',
        reasonsReplacementStats: 'stats/reasonsReplacementStats',
        responseByTimeStats: 'stats/responseByTime',
        topCandidateStats: 'stats/topCandidates',
        isFullPage: 'stats/isFullPage',
        isSingleEntity: 'users/isSingleEntity',
        selectedEntity: 'stats/selectedEntity',
        hubsOptions: 'users/manageableHubs',
      }),
      totalOffersPublished: function () {
        return this.completionOfRequests.num_offers_published
      },
      minTimeFoundCandidate: function () {
        return this.responseByTimeStats.min_time_found_candidate
      },
      isChart: function() {
        return this.isSingleEntity || (!this.isSingleEntity && this.selectedEntity)
      },
      hasManyHubs() {
        return this.hubsOptions.length > 1
      },
      isChartHub: function() {
        return this.hasManyHubs && this.selectedEntity
      }
    },
    methods: {
      ...mapActions({
        getOffersByServicesStats: 'stats/getOffersByServicesStats',
        getOffersByOccupationsStats: 'stats/getOffersByOccupationsStats',
        getOffersByHubsStats: 'stats/getOffersByHubsStats',                          
        getOffersByEntitiesStats: 'stats/getOffersByEntitiesStats'
      }),
      filtersChanged: function (filters) {
        this.filters = filters
        this.$emit('offersFilters', this.filters);
      },
      changeToggle: function (typeOfChart, toggleShowAll) {
        this.filters['toggle_show_all'] = toggleShowAll;
        if (typeOfChart === 'services') {
          this.getOffersByServicesStats({ filters: this.filters });
        } else if (typeOfChart === 'occupations') {
          this.getOffersByOccupationsStats({ filters: this.filters });
        } else if (typeOfChart === 'entities') {
          this.getOffersByEntitiesStats({ filters: this.filters });
        } else if (typeOfChart === 'hubs') {
          this.getOffersByHubsStats({ filters: this.filters });
        }
      },
      enableToggleButton: function (typeOfChart) {
        if (typeOfChart === 'services') {
          return this.offersByServicesStats.show_toggle_button
        } else if (typeOfChart === 'entities') {
            return this.offersByEntitiesStats.show_toggle_button
        } else if (typeOfChart === 'occupations') {
          return this.offersByOccupationsStats.show_toggle_button
        } else if (typeOfChart === 'hubs') {
          return this.offersByHubsStats.show_toggle_button
        }
      }
    }
  }
</script>

<style type="text/scss">

  .stats-cards .card {
    margin: 0 auto;
    margin-top: 40px;
    box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.1);
    max-width: 1200px;
  }
  .stats-cards .card .card-header {
    background: #f7f7f7;
  }
  .stats-cards .card .card-header .card-title {
    font-size: 14px;
  }


  .statistic-number .number-highlight {
    font-size: 2.3rem;
    color: #e51349;
    font-weight: bold;
  }

  .statistic-number .text-content {
    font-size: 1.1rem;
    width: 80%;
    margin: 10px auto;
  }

  .completion-of-requests .highcharts-pie-series .highcharts-point {
    stroke: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/stats/Stats.vue